import { Link } from "react-router";
import logoMark from "@/src/common/assets/images/logo.png";
import logoFull from "@/src/common/assets/images/upsquad-full.png";
import { SITE_ROUTES } from "@/src/common/constants/site-routes";

interface SiteLogoProps {
	className?: string;
	tone?: "ink" | "white";
}

export function SiteLogo({ className = "", tone = "ink" }: SiteLogoProps) {
	const isWhite = tone === "white";

	return (
		<Link to={SITE_ROUTES.HOME} aria-label="UpSquad — back to home" className={`inline-flex items-center gap-2 ${className}`}>
			{isWhite ? (
				<>
					<img src={logoMark} alt="" aria-hidden="true" decoding="async" className="size-8 shrink-0" />
					<span className="font-sans text-base font-bold tracking-tight text-white">UpSquad</span>
				</>
			) : (
				<img src={logoFull} alt="UpSquad" height={22} decoding="async" className="h-[22px] w-auto" />
			)}
		</Link>
	);
}
